import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AdminUserService } from 'app/services/admin/user.service';
import { LocalService } from 'app/services/local.service';
import { CustomerService } from 'app/services/customer.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  isShow = false;
  isAdminLoggedIn = false;
  isMenuOpen = false;
  isSticky = false;
  openDropdown: 'services' | 'information' | 'account' | null = null;

  constructor(
    private _loginService: CustomerService,
    private _adminUserService: AdminUserService,
    private _localService: LocalService,
    private _router: Router,
    private _changeDetectorRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.isShow = !!(this._localService.getJsonValue('token') || this._localService.getJsonValue('adminToken'));
    this.isAdminLoggedIn = !!this._localService.getJsonValue('adminToken');

    this._loginService.isLogin.subscribe((res) => {
      if (res) {
        this.isShow = true;
        this.isAdminLoggedIn = false;
      } else if (!this._localService.getJsonValue('adminToken')) {
        this.isShow = false;
        this.isAdminLoggedIn = false;
      }
      this._changeDetectorRef.markForCheck();
    });

    this._adminUserService.isLogin.subscribe((resAd) => {
      if (resAd) {
        this.isShow = true;
        this.isAdminLoggedIn = true;
      } else if (!this._localService.getJsonValue('token')) {
        this.isShow = false;
        this.isAdminLoggedIn = false;
      }
      this._changeDetectorRef.markForCheck();
    });
  }

  get dashboardLink(): string {
    return this.isAdminLoggedIn ? '/admin/dashboard' : '/customer/dashboard';
  }

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.openDropdown = null;
    }
  }

  closeMenu(): void {
    if (this.isDesktopView()) {
      return;
    }

    this.isMenuOpen = false;
    this.openDropdown = null;
  }

  toggleDropdown(menu: 'services' | 'information' | 'account', event: Event): void {
    if (this.isDesktopView()) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.openDropdown = this.openDropdown === menu ? null : menu;
  }

  isDropdownOpen(menu: 'services' | 'information' | 'account'): boolean {
    return this.openDropdown === menu;
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    if (!this.isDesktopView()) {
      this.isSticky = false;
      return;
    }
    this.isSticky = window.scrollY > 80;
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    if (this.isDesktopView()) {
      this.isMenuOpen = false;
      this.openDropdown = null;
    } else {
      this.isSticky = false;
    }
  }

  logOut(): void {
    this._localService.clearValues();
    this._router.navigate(['/sign-in']);
    this._loginService.isLogin.next(false);
    this._adminUserService.isLogin.next(false);
    this.isShow = false;
    this.isAdminLoggedIn = false;
    this.closeMenu();
    this._changeDetectorRef.markForCheck();
  }

  private isDesktopView(): boolean {
    return typeof window !== 'undefined' && window.innerWidth >= 992;
  }
}
